import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { List } from '@mui/material';
import {
    StyledDrawer,
    LogoContainer,
    StyledListItemButton,
    StyledListItemIcon,
    StyledListItemText,
} from '../styles/navigationStyles';
import { NavigationIcon } from './NavigationItem';
import * as routes from '../../../constants/routes';
import { ARIA_LABELS } from '../constants/navigationConfig';

/**
 * Componente de navegação desktop (drawer lateral)
 */
const DesktopNav = ({ navigationItems, activeIndex, onNavigate, currentTheme }) => {
    return (
        <StyledDrawer variant="permanent" anchor="left">
            <LogoContainer>
                <NavLink to={routes.R_ROOT} aria-label={ARIA_LABELS.LOGO_LINK}>
                    <figure>
                        <img src={currentTheme.logo} alt={currentTheme.alt} />
                    </figure>
                </NavLink>
            </LogoContainer>

            <List component="nav" disablePadding aria-label={ARIA_LABELS.MAIN_NAVIGATION}>
                {navigationItems.map((item, index) => (
                    <StyledListItemButton
                        key={item.id}
                        selected={activeIndex === index}
                        onClick={() => onNavigate(item)}
                        className={item.className}
                        aria-label={item.label}
                        aria-current={activeIndex === index ? 'page' : undefined}
                        data-testid={`mainMenuDesktop_${item.className}_btn`}
                    >
                        <StyledListItemIcon>
                            <NavigationIcon item={item} />
                        </StyledListItemIcon>
                        <StyledListItemText primary={item.label} />
                    </StyledListItemButton>
                ))}
            </List>
        </StyledDrawer>
    );
};

DesktopNav.propTypes = {
    navigationItems: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            icon: PropTypes.elementType.isRequired,
            route: PropTypes.string.isRequired,
            className: PropTypes.string,
            showBadge: PropTypes.bool,
        })
    ).isRequired,
    activeIndex: PropTypes.number.isRequired,
    onNavigate: PropTypes.func.isRequired,
    currentTheme: PropTypes.shape({
        logo: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
    }).isRequired,
};

export default DesktopNav;